import {
  filtersData,
  IFiltersData,
} from '../../shopListingBottomSheet/utils/index';
import {useBuyersListingFilters} from '../../../../hooks/filters/useBuyersListingFilter';

const FiltersBuyersList = () => {
  const {resetFilter, buyersFilters, setBuyersFilter} =
    useBuyersListingFilters();
  return (
    <div className="flex gap-2 items-center">
      <div className="flex gap-2 items-center">
        {buyersFilters.input_guid?.map(item => (
          <div
            className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap"
            key={item.guid}
          >
            {item.title}
            <i
              className="mr-3 text-lg icon-nameClose-remove"
              onClick={() =>
                setBuyersFilter(
                  'input_guid',
                  buyersFilters.input_guid.filter(
                    inputGroup => inputGroup.guid !== item.guid,
                  ),
                )
              }
            />
          </div>
        ))}
      </div>
      {buyersFilters.order_by && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <i
            className="mr-3 text-lg icon-nameClose-remove"
            onClick={() => resetFilter('order_by')}
          />
          <span>
            {
              filtersData.find(
                (item: IFiltersData) => item.value === buyersFilters.order_by,
              )?.title
            }
          </span>
        </div>
      )}

      {buyersFilters.has_immediate === true && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <span>آگهی فوری</span>
          <i
            className="mr-3 text-lg icon-nameClose-remove"
            onClick={() => resetFilter('has_immediate')}
          />
        </div>
      )}
    </div>
  );
};

export default FiltersBuyersList;
